/**
 * @group DOM Attribute
 */
const name = 'list-limit';

export {name as LIST_LIMIT};
